import { render, staticRenderFns } from "./FormatSelector.vue?vue&type=template&id=853c1dee&scoped=true&"
import script from "./FormatSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSelector.vue?vue&type=style&index=0&id=853c1dee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853c1dee",
  null
  
)

export default component.exports